import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { SelectSong } from "./pages/SelectSong/SelectSong";
import { SelectCategory } from "./pages/SelectCategory/SelectCategory";
import { SongPage } from "./pages/SongPage/SongPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <SelectCategory />,
  },
  {
    path: "category/:catValue",
    element: <SelectSong/>,
  },
  {
    path: "category/:catValue/:songId",
    element: <SongPage/>,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
